import styled from 'styled-components';
import { StyledAlertProps } from './Alert.types';

export const StyledAlert = styled.div<StyledAlertProps>`
  &:empty {
    display: none;
  }

  ${(props) => props.customStyle}
`;
